import { render, staticRenderFns } from "./RightSideBar.vue?vue&type=template&id=a44bcc64"
import script from "./RightSideBar.vue?vue&type=script&lang=js"
export * from "./RightSideBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports